export const formatRankNumber = (rank: number) => `Tier ${rank}`;
